<template>
  <div class="relative w-full main-page">
    <div
      class="pt-5 flex items-between client-status-block rounded-lg top relative"
    >
      <main
        class="c-container py-10 prose max-w-none flex flex-col gap-6 overflow-y-scroll scroll-styling"
      >

          <h1>Приложение 1 к договору возмездного оказания услуг</h1>
          <h2>Правила оплаты и возврата денежных средств</h2>

    <p>
      Настоящие Правила оплаты и возврата денежных средств (далее – Правила) регулируют отношения между Исполнителем и Заказчиком, связанные с оплатой Услуг по Договору и возвратом денежных средств.
    </p>

    <h3>1. Способы оплаты</h3>
    <p>
      Оплата Услуг осуществляется в безналичном порядке одним из способов, указанных на Сайте, по выбору Заказчика путем зачисления денежных средств на счет Исполнителя.
    </p>

    <h3>2. Оплата через интернет</h3>
    <p>
      При оплате Услуг через интернет к оплате принимаются карты VISA, MasterCard (далее – банковские карты). Осуществление платежей производится в соответствии с Правилами международных платежных систем VISA и MasterCard (далее – платежные системы) на принципах соблюдения конфиденциальности и безопасности совершения платежа с использованием современных методов проверки, шифрования и передачи данных по закрытым каналам связи. По вопросам правил и порядка осуществления оплаты посредством платежных систем Заказчик руководствуется правилами соответствующих платежных систем и обращается напрямую к операторам соответствующих платежных систем за разъяснениями и консультациями. Исполнитель настоящим оставляет за собой право оказывать информационную поддержку относительно осуществления оплаты Услуг с помощью платежных систем в пределах своих компетенций, однако ничто в настоящем приложении не обязывает его осуществлять такую информационную поддержку, отвечать за полноту предоставленной информации или нести иные последствия выбора способа оплаты Услуг и/или платежной системы Заказчиком.
    </p>

    <h3>3. Заказ Услуг и оплата банковской картой</h3>
    <p>
      Для оплаты Услуг банковской картой нужно заказать Услугу любым удобным способом: позвонить по контактному номеру телефона или оставить заявку на Сайте. Исполнитель направит Заказчику ссылку на оплату заказа.
    </p>

    <h3>4. Защищенная платежная страница</h3>
    <p>
      Оплата заказа осуществляется после перехода по ссылке и перенаправления на защищенную платежную страницу оператора платежной системы и/или соответствующего банка для ввода реквизитов банковской карты. Соединение с платежной страницей и передача информации осуществляются в защищенном режиме с использованием технологии 3D Secure. На странице для ввода данных банковской карты Заказчику необходимо ввести данные банковской карты: номер карты, имя владельца карты, срок действия карты, трёхзначный код безопасности (CVV2 для VISA или CVC2 для MasterCard). Все необходимые данные пропечатаны на самой карте. Трёхзначный код безопасности — это три цифры, находящиеся на обратной стороне карты. Если банк Заказчика поддерживает технологию безопасного проведения интернет-платежей MasterCard SecureCode, Verified by Visa, для проведения платежа может потребоваться ввод специального пароля.
    </p>

    <h3>5. Конфиденциальность платежных реквизитов</h3>
    <p>
      Реквизиты банковской карты Заказчика не хранятся на сервере Исполнителя или на Сайте, Исполнитель доступа к платежным реквизитам Заказчика не имеет. Конфиденциальность сообщаемой Заказчиком информации, включая персональные данные и платежные реквизиты, обеспечивается оператором соответствующей платежной системы и / или банком Заказчика. Введенная Заказчиком информация, включая платежные реквизиты, данные банковской карты, не предоставляется третьим лицам, за исключением случаев, предусмотренных законодательством Республики Казахстан.
    </p>

    <h3>6. Случаи отказа в совершении платежа</h3>
    <p>
      В проведении платежа может быть отказано банком, в т.ч. в следующих случаях:
    </p>
    <ul>
      <li>6.1. банковская карта не предназначена для совершения платежей через интернет; Заказчик может узнать об этом, обратившись в обслуживающий банк.</li>
      <li>6.2. недостаточно средств для оплаты на банковской карте. Подробнее о наличии средств на банковской карте Заказчик может узнать, обратившись в банк, выпустивший банковскую карту;</li>
      <li>6.3. данные банковской карты введены неверно;</li>
      <li>6.4. истек срок действия банковской карты. Срок действия карты, как правило, указан на лицевой стороне карты (это месяц и год, до которого действительна карта). Подробнее о сроке действия карты Заказчик может узнать, обратившись в банк, выпустивший банковскую карту.</li>
    </ul>

    <h3>7. Apple Pay</h3>
    <p>
      При оплате с помощью Apple Pay (если такой способ предусмотрен на Сайте) необходимо выбрать карту из приложения «Wallet», воспользоваться код-паролем или иным способом аутентификации, в зависимости от того, какой способ выбран в приложении.
    </p>

    <h3>8. Samsung Pay</h3>
    <p>
      При оформлении заказа с помощью Samsung Pay (если такой способ предусмотрен на Сайте) необходимо нажать «Оплатить Samsung Pay», ввести Samsung Account и подтвердить покупку на смартфоне (по отпечатку пальца, радужке или PIN-коду Samsung Pay).
    </p>

    <h3>9. Ответственность Исполнителя</h3>
    <p>
      Исполнитель не контролирует программно-аппаратный комплекс платежной системы и/или банка. Если в результате каких-либо ошибок произошло списание денежных средств Заказчика, но платеж не был авторизован платежной системой и / или банком, обязанности по возврату денежных средств Заказчику возлагаются на оператора платежной системы и / или соответствующий банк.
    </p>

    <h3>10. Основания для возврата денежных средств</h3>
    <p>
      Возврат уплаченных Заказчиком денежных средств может быть осуществлен в случаях:
    </p>
    <ul>
      <li>10.1. Услуга не оказана в установленный срок по вине Исполнителя;</li>
      <li>10.2. Заказчик до начала оказания Услуги обратился с уведомлением об отказе от Договора и возврате денежных средств;</li>
      <li>10.3. в случаях, указанных в п. 14 Правил.</li>
    </ul>

    <h3>11. Порядок подачи заявления о возврате</h3>
    <p>
      Полный или частичный возврат уплаченных Заказчиком денежных средств производится Исполнителем на основании письменного заявления Заказчика, направленного на электронную почту Исполнителя info@rdke.kz с последующим направлением оригинала на почтовый адрес Исполнителя: 010000, Республика Казахстан, г. Астана, Сарыаркинский район, ул. Ауэзова, д. 2, НП 1. Исполнитель вправе потребовать от Заказчика заполнения утвержденной формы заявления о возврате денежных средств.
    </p>

    <h3>12. Размер возврата и комиссии</h3>
    <p>
      Возврат денежных средств в случаях, предусмотренных п.п. 10.1. и 10.2. Правил, осуществляется в объеме поступивших денежных средств на банковский счет Исполнителя за оказание Услуг по Договору. Суммы комиссий платежных организаций, банков (микрофинансовых организаций), удержанные при перечислении денежных средств, являются фактически понесенными расходами Исполнителя и возврату Заказчику не подлежат.
    </p>

    <h3>13. Форма расчета и процентные ставки</h3>
    <p>
      Расчеты с Заказчиком осуществляются в той же форме, в которой производилась оплата Услуг: на банковский счет Заказчика, если оплата производилась с использованием собственных денежных средств либо в адрес банка (микрофинансовой организации), если оплата производилась с использованием заемных средств. Исполнитель не возмещает Заказчику сумму начисленных процентов за пользование денежными средствами, подлежащих оплате Заказчиком в соответствии с договором банковского займа (договором о предоставлении микрокредита).
    </p>

    <h3>14. Возврат при отказе от Курса</h3>
    <p>
      В случае, если в течение 30 (тридцати) календарных дней с даты оказания Услуг по Договору Заказчик / Пользователь утратил интерес к выбранному Курсу по причинам, не связанным с нарушением Исполнителем условий Договора, Заказчик вправе обратиться за возвратом части уплаченных средств в размере, пропорциональном данным, отражаемым в Личном кабинете Пользователя на дату обращения Заказчика, но не более чем 50 % от уплаченной за оказанную Услугу суммы денежных средств. Такое заявление Заказчика является заявлением об изменении цены согласно п. 2 ст. 385 ГК. При этом Онлайн-доступ к Курсу прекращается. Если Услуги оплачены с использованием денежных средств, предоставленных в соответствии с договором банковского займа (договором о предоставлении микрокредита), сумма к возврату рассчитывается исходя из суммы денежных средств, полученных Исполнителем.
    </p>

    <h3>15. Сроки возврата после истечения 30 дней</h3>
    <p>
      По истечении 30 (тридцати) календарных дней с даты предоставления Исполнителем Онлайн-доступа изменение цены и возврат денежных средств не производится.
    </p>

    <h3>16. Исполнение обязательства по возврату</h3>
    <p>
      Обязательство Исполнителя по возврату денежных средств считается исполненным с момента списания денежных средств со счета Исполнителя. Конкретный срок зачисления денежных средств на счет Заказчика зависит от банка, эмитировавшего банковскую карту Заказчика, и/или банка (микрофинансовой организации), предоставившего (предоставившей) заем (микрокредит), если оплата услуг Исполнителя была произведена с использованием денежных средств, предоставленных в соответствии с договором банковского займа (договором о предоставлении микрокредита).
    </p>

    <h3>17. Прекращение Онлайн-доступа</h3>
    <p>
      Онлайн-доступ к Курсу прекращается в течение 1 (одного) рабочего дня с даты принятия решения Исполнителем о возврате денежных средств.
    </p>
     
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.prose :where(h1, h2, h3) {
  color: #111827;
}
.prose a {
  text-decoration: underline;
}
</style>
